import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { helix } from "ldrs";
import { message } from "antd";

const roleAccessMap = {
  admin: [
    "/dashboard",
    "/outlet",
    "/observatory",
    "/onboarding",
    "/runCampaign",
    "/campaigns",
    "/products",
    "/users",
    "/sales",
    "/clientStats",
    "/campaignStats",
    "/commerce",
    "/geography",
    "/productPerformance",
    "/wholesaler",
    "/wholesalerCampaigns",
    "/wholesalerStats",
    "/orders",
    "/orderAnalytics",
    "/agentAnalytics",
    "/settings",
    "/privacy-policy/download",
    "/agentRoutes",
    "/broadcast",
    "/stocks",
    "/stockAnalysis",
    "/agentManagerHome",
    "/tradeCalls",
    "/calls",
    "/telesalesDash",
    "/focusBrands",
    "/rider",
    "/fulfillmentDash",
    "/schedule",
    "/userRider",
    "/reviewOrders",
    "/brandIntelligenceDash",
    "/broadcastReport/:broadcastId",
    "/agentOrdersManager",
    "/manifest",
    "/agentPerformance",
    "/customerAnalytics",
    "/rebate",
  ],
  tmm: [
    "/tmmHome",
    "/tmOrders",
    "/agentOrdersManager",
    "/agentCampaignStats",
    "/settings",
  ],
  tdr: [
    "/tdrHome",
    "/tdrOrders",
    "/agentCampaignStats",
    "/taRoutes",
    "/agentOrdersManager",
    "/settings",
  ],
  client: [
    "/clientHome",
    "/orderAnalytics",
    "/productPerformance",
    "/stocks",
    "/sales",
    "/clientCampaigns",
    "/clientCampaignStats",
    "/settings",
    "/privacy-policy/download",
  ],
  clientManager: [
    "/clientManagerHome",
    "/clientOrders",
    "/clientManagerCampaigns",
    "/clientManagerCampaignStats",
    "/clientCampaignStats",
    "/settings",
    "/privacy-policy/download",
  ],
  fc: ["/fcHome", "/fcCampaignStats", "/settings"],
  agentManager: [
    "/agentManagerHome",
    "/orderAnalytics",
    "/agentAnalytics",
    "/tradeCalls",
    "/focusBrands",
    "/agentPerformance",
    "/settings",
  ],
  partner: ["/focusBrands", "/settings"],
  rider: ["/rider", "/settings"],
  fulfillmentProvider: [
    "/schedule",
    "/agentManagerHome",
    "/orderAnalytics",
    "/fulfillmentDash",
    "/userRider",
    "/manifest",
    "/settings",
  ],
};

const ProtectedRoute = ({ children }) => {
  helix.register();
  const { getUserInfo, isLoggedIn, isAuthLoading } = useAuth();
  const location = useLocation();
  const expiry = parseInt(localStorage.getItem("sessionExpiry"));
  const now = Date.now();

  if (isAuthLoading) {
    return (
      <div className="center__loader container">
        <l-helix size="80" speed="2.5" color="#B19CD7"></l-helix>
      </div>
    );
  }

  if (!isLoggedIn || isNaN(expiry) || now > expiry) {
    return <Navigate to="/login" replace />;
  }

  // Get role from stored user info
  const { role } = getUserInfo();
  const allowedRoutes = roleAccessMap[role] || [];
  const currentPath = location.pathname;

  // Role not permitted for this path
  if (!allowedRoutes.some((route) => currentPath.startsWith(route))) {
    message.warning("🚫 This page has not been enabled for your account.");
    const fallback = allowedRoutes[0] || "/login";
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default ProtectedRoute;
